/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponseDto } from '../models/AuthResponseDto';
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { ForgotPasswordDto } from '../models/ForgotPasswordDto';
import type { LoginDto } from '../models/LoginDto';
import type { LogoutDto } from '../models/LogoutDto';
import type { MeResponseDto } from '../models/MeResponseDto';
import type { OkResponseDto } from '../models/OkResponseDto';
import type { RefreshDto } from '../models/RefreshDto';
import type { RegisterDto } from '../models/RegisterDto';
import type { ResetPasswordDto } from '../models/ResetPasswordDto';
import type { UpdateProfileDto } from '../models/UpdateProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * @returns AuthResponseDto Успешная регистрация — tokens + user
     * @throws ApiError
     */
    public static authControllerRegister({
        requestBody,
    }: {
        requestBody: RegisterDto,
    }): CancelablePromise<AuthResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/register',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AuthResponseDto Успешный вход — tokens + user
     * @throws ApiError
     */
    public static authControllerLogin({
        requestBody,
    }: {
        requestBody: LoginDto,
    }): CancelablePromise<AuthResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AuthResponseDto Новые tokens
     * @throws ApiError
     */
    public static authControllerRefresh({
        requestBody,
    }: {
        requestBody: RefreshDto,
    }): CancelablePromise<AuthResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Сессия завершена
     * @throws ApiError
     */
    public static authControllerLogout({
        requestBody,
    }: {
        requestBody: LogoutDto,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/logout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns MeResponseDto Профиль текущего пользователя
     * @throws ApiError
     */
    public static authControllerMe(): CancelablePromise<MeResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/me',
        });
    }
    /**
     * @returns MeResponseDto Профиль обновлён
     * @throws ApiError
     */
    public static authControllerUpdateProfile({
        requestBody,
    }: {
        requestBody: UpdateProfileDto,
    }): CancelablePromise<MeResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/auth/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Пароль изменён
     * @throws ApiError
     */
    public static authControllerChangePassword({
        requestBody,
    }: {
        requestBody: ChangePasswordDto,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/change-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Письмо сброса отправлено (если email существует)
     * @throws ApiError
     */
    public static authControllerForgotPassword({
        requestBody,
    }: {
        requestBody: ForgotPasswordDto,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OkResponseDto Пароль сброшен
     * @throws ApiError
     */
    public static authControllerResetPassword({
        requestBody,
    }: {
        requestBody: ResetPasswordDto,
    }): CancelablePromise<OkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/reset-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
